var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"fields mb-4"},[_c('h4',[_vm._v(_vm._s(_vm.$t('Unit')))]),_c('ConfigFieldChoice',_vm._b({},'ConfigFieldChoice',{
        id: 'unit_weight',
        label: 'Weight',
        disabled: false,
        description: 'Set the weight unit. Used for the weight of the cargo',
        values: _vm.fieldValues('unit_weight'),
        target: 'game'
      },false)),_c('ConfigFieldChoice',_vm._b({},'ConfigFieldChoice',{
        id: 'unit_length',
        label: 'Length',
        disabled: false,
        description:
          'Set the length unit. Used for the distance of travel (job or point on the map)',
        values: _vm.fieldValues('unit_length'),
        target: 'game'
      },false)),_c('ConfigFieldChoice',_vm._b({},'ConfigFieldChoice',{
        id: 'unit_degrees',
        label: 'Degrees',
        disabled: false,
        description:
          'Set degrees unit. Used for the temperature of water, oil and engine',
        values: _vm.fieldValues('unit_degrees'),
        target: 'game'
      },false)),_c('ConfigFieldChoice',_vm._b({},'ConfigFieldChoice',{
        id: 'unit_consumption',
        label: 'Consumption',
        disabled: false,
        description: 'Set the consumption unit',
        values: _vm.fieldValues('unit_consumption'),
        target: 'game'
      },false)),_c('ConfigFieldChoice',_vm._b({},'ConfigFieldChoice',{
        id: 'unit_volume',
        label: 'Volume',
        disabled: false,
        description: 'Set the volume unit. Used for the fuel capacity',
        values: _vm.fieldValues('unit_volume'),
        target: 'game'
      },false)),_c('ConfigFieldChoice',_vm._b({},'ConfigFieldChoice',{
        id: 'unit_pressure',
        label: 'Pressure',
        disabled: false,
        description:
          'Set the pressure unit. Used for the Air pressure or oil pressure',
        values: _vm.fieldValues('unit_pressure'),
        target: 'game'
      },false)),_c('ConfigFieldChoice',_vm._b({},'ConfigFieldChoice',{
        id: 'unit_speed',
        label: 'Speed',
        disabled: false,
        description: 'Set the speed unit',
        values: _vm.fieldValues('unit_speed'),
        target: 'game'
      },false)),_c('ConfigFieldChoice',_vm._b({},'ConfigFieldChoice',{
        id: 'unit_currency',
        label: 'Currency',
        disabled: false,
        description: 'Set the currency unit',
        values: _vm.fieldValues('unit_currency'),
        target: 'game'
      },false))],1)
}
var staticRenderFns = []

export { render, staticRenderFns }